/** 端口 */
export const ShowPort = {
    /** 骑手 */
    RIDER_APP: 'RIDER_APP',

    /** 客户端 */
    USER_APP: 'USER_APP',

};

/** 表格列表字段 */
export const MainTableFields = {
    /** 广告位名称 */
    title: 'title',

    /** 使用位置 */
    position: 'previewImageUrl',

    /** 文本类型 */
    type: 'textType',

};

/** 文本类型 */
export const TextType = {
    /** 文本 */
    '0': '文本',

    /** 富文本 */
    '1': '富文本'
};

/** 表格操作 */
export const TableAction = {
    /** 标题 */
    title: 'title',

    /** 预览 */
    preview: 'preview'
}